export const DESIGN_ENVIRONMENT_DTO = {
  id: 4,
  name: 'DESIGN'
}
